import React from 'react';
import Validator from './components/Validator';

function App() {
  return (
    <div className="App">
      <h1>Проверка JSON по AVRO схеме</h1>
      <Validator />
    </div>
  );
}

export default App;